var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-select", {
    attrs: {
      value: _vm.value,
      "allow-clear": "",
      "show-search": "",
      "filter-option": _vm.useLocalFilter,
      placeholder: _vm.$t("common.select-text", {
        text: _vm.$t("lbl_term_of_payment")
      }),
      "option-filter-prop": "children",
      loading: _vm.loading,
      disabled: _vm.disabled,
      options: _vm.options
    },
    on: { change: _vm.onChange },
    scopedSlots: _vm._u([
      {
        key: "suffixIcon",
        fn: function() {
          return [
            _vm._v(" " + _vm._s(_vm.$tc("common.day", Number(_vm.value))) + " ")
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }